module.exports = __webpack_public_path__ + "img/00053.f3504ff1.webp";